module.exports = __webpack_public_path__ + "static/media/POS Device Certification Documents.dba831c6.pdf";